import * as React from 'react'

function GmailIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={8} {...props}>
      <defs>
        <style>{'.prefix__a{fill:#fff}'}</style>
      </defs>
      <path
        className="prefix__a"
        d="M.96 2.525q.19.14 1.144.829t1.462 1.062l.237.178q.181.137.3.221t.29.189a1.653 1.653 0 00.321.157.852.852 0 00.279.052h.011a.853.853 0 00.279-.052 1.655 1.655 0 00.321-.157q.17-.1.29-.189t.3-.221l.237-.178 2.612-1.891a2.712 2.712 0 00.681-.716A1.582 1.582 0 0010 .931a.911.911 0 00-.265-.658A.845.845 0 009.107 0H.893a.783.783 0 00-.661.3A1.208 1.208 0 000 1.059a1.392 1.392 0 00.307.794 2.829 2.829 0 00.653.672z"
      />
      <path
        className="prefix__a"
        d="M9.442 3.131q-1.83 1.247-2.779 1.938-.318.236-.516.368a3.178 3.178 0 01-.527.27 1.6 1.6 0 01-.614.138h-.012a1.6 1.6 0 01-.614-.138 3.18 3.18 0 01-.527-.27q-.2-.132-.516-.368-.753-.556-2.773-1.938A2.96 2.96 0 010 2.642v4.46a.868.868 0 00.262.635.857.857 0 00.631.264h8.214a.857.857 0 00.631-.264.868.868 0 00.262-.632v-4.46a3.084 3.084 0 01-.558.486z"
      />
    </svg>
  )
}

export default GmailIcon
